const Layout1Settings = {
  leftSidebar: {
    show: true,
    mode: 'full', // full, close, compact, mobile,
    theme: 'dark', // View all valid theme colors inside MatxTheme/themeColors.js
    bgOpacity: 0.96, // 0 ~ 1
    bgImgURL: '/assets/images/sidebar/sidebar-bg-dark.jpg',
    background: '#1a2038',
    color: '#ffffff',
  },
  topbar: {
    show: true,
    fixed: true,
    theme: 'purpleDark1', // View all valid theme colors inside MatxTheme/themeColors.js
  },
};

export default Layout1Settings;
